import React from "react";
import { colors } from "../../../styles/Colors";
import { bootstrapClassName } from "../../../styles/Styles";


export default function NavItem(props) {
    return (
        <li
            id={window.location.pathname === props.link ? "active-link" : null}
            className={bootstrapClassName.navItem}
        >
            <a
                className="nav-link w-100 d-flex align-items-center my-2 myitem  ms-2 "
                aria-current="page"
                href={props.link}
            >
                <div className="d-flex ml-2 flex-row align-items-center  myitem2">
                    {props.icon}
                    <span style={styles.menuText}>
                        {props.title.toUpperCase()}
                    </span>
                </div>
            </a>
        </li>
    );
}

const styles = {
    menuText: {
        marginLeft: 10,
        fontSize: 16,
        color: colors.text,
    },
  

};
